import { render, staticRenderFns } from "./collect-minimization-filter.vue?vue&type=template&id=9d963c5a"
import script from "./collect-minimization-filter.vue?vue&type=script&lang=js"
export * from "./collect-minimization-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports